import { useRefinementList, useMenu } from 'react-instantsearch';

export function VirtualRefinementList(props: any) {
    useRefinementList(props);
 
    return null;
}

export function VirtualUseMenu(props: any) {
    useMenu(props);
 
    return null;
}